import { render } from "./selectMailTemplateModal.vue?vue&type=template&id=e61eba1c&scoped=true&ts=true"
import script from "./selectMailTemplateModal.vue?vue&type=script&lang=ts"
export * from "./selectMailTemplateModal.vue?vue&type=script&lang=ts"

import "./selectMailTemplateModal.vue?vue&type=style&index=0&id=e61eba1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e61eba1c"]])

export default __exports__